export default __webpack_public_path__ + "static/media/icone-erro.b46a6544.png";